"use client";

import { Avatar } from "@chakra-ui/react";
import { brand_name } from "@/app/constants";

export function BrandLogo() {
  return (
    <Avatar.Root size="xs" shape="rounded">
      <Avatar.Fallback name={brand_name} />
      <Avatar.Image src="/logo-nobg.v3.webp" alt={`${brand_name} logo`} />
    </Avatar.Root>
  );
}
